import { computed, Ref, ref } from '@vue/composition-api';
import { GenderType } from '@ad/tt_ads_common_enums';
import { i18n } from './../../../i18n';
import { AdgroupFormData, CampaignFormData } from '@tt4b/ttam-enums';
import { useStdAdgroupIs } from '@tt4b/ttam-hooks';

export const GENDER_OPTIONS = () => [
  {
    name: i18n.t('adgroup_no_limit'),
    value: GenderType.NO_LIMIT,
  },
  {
    name: i18n.t('adgroup_male'),
    value: GenderType.MALE,
  },
  {
    name: i18n.t('adgroup_female'),
    value: GenderType.FEMALE,
  },
];

export function useGenderName(opt: { gender: Ref<number> }) {
  const { gender } = opt;
  const genderName = computed(() => GENDER_OPTIONS().find(item => item.value === gender.value)?.name);
  return {
    genderName,
  };
}

export function useGenderOPtions() {
  return {
    genderOptions: GENDER_OPTIONS,
  };
}

export function usePropsVisible(options: { campaignData: Ref<CampaignFormData>; adgroupData: Ref<AdgroupFormData> }) {
  const { campaignData, adgroupData } = options;
  const { isSelectedIndustryType } = useStdAdgroupIs({
    campaignFormData: campaignData,
    adgroupFormData: adgroupData,
  });
  const visible = computed(() => !isSelectedIndustryType.value);
  return {
    visible,
  };
}
